<div *ngIf="like_count > 0" class="comment-reactions-container d-flex">
	<span class="material-icons center-btn-text blue-thumb-icon">thumb_up</span>
  <div class="pl-1 center-btn-text font-size-12 text-gray-600">{{like_count}}</div>
</div>
